// extracted by mini-css-extract-plugin
export default {"preview":"NewsLikeContent_preview__WKUAR","previewBox":"NewsLikeContent_previewBox__cP7wk"};